import styled from 'styled-components';

export const ChartContainer = styled.div`
    background: #fff;
    padding: 24px;
    border-radius: 8px;
    box-shadow: 0px 3px 12px rgba(81, 69, 159, 0.08);
    height: 100%;
    min-height: 280px;
    flex: 1;
    min-width: 0;
`;

export const ChartTitle = styled.h3`
    font-size: 18px;
    font-weight: 700;
    color: #25272e;
    margin: 0 0 24px 0;
`;
